//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OrdenesAPI from '@/api/promotores/ordenes.api'
import SadasiForm from './SadasiForm.vue'
import SkyParkForm from './SkyParkForm.vue'
import OnisVidaForm from './OnisVidaForm.vue'
import IHMForm from './IHMForm.vue'

export default {
	props: {
		tarea: {
			type: Object,
		}
	},

	data() {
		return {
      tarea_: JSON.parse(JSON.stringify(this.tarea)),
			loading: false,
      ratio: 20,
      tab: 'config',
      statusList: [
        { value: 'nuevo', label: 'Nuevo' },
        { value: 'completado', label: 'Completado' },
      ]
		}
	},

  computed: {
    form() {
      return ({
        sadasi: SadasiForm,
        skypark: SkyParkForm,
        onisvida: OnisVidaForm,
        ihm: IHMForm,
      })[this.tarea_.organizacion]
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    },

    hide() {
      this.$refs.dialog.hide();
    },

    removePromotor() {
      this.tarea_.usuario = null
      this.tarea_.status = 'nuevo'
    },

		async submit() {
			try {
				this.loading = true
      
        if (this.tarea_.usuario) {
          this.tarea_.usuario = this.tarea_.usuario_id
        }

				const tarea = await OrdenesAPI.update(this.tarea_._id, this.tarea_)

				this.$emit('ok', tarea)
				this.hide()
			} finally {
				this.loading = false
			}
		},
  },
};
